module.exports = __webpack_public_path__ + "static/media/stock-2.7f20f4fe.jpg";